<ion-modal #modal class="modal-lightbox">
    <div class="position-relative modal-lightbox--content" *ngIf="lightboxImage">
        <img class="modal-lightbox--image" src="{{ lightboxImage.image_url || lightboxImage }}" />
        <div class="gallery-lightbox--close-button">
            <lib-close-button backgroundColor="#ffffff" [buttonSize]="35" (onClick)="dismissLightbox()" />
        </div>
    </div>
</ion-modal>

<ion-grid *ngIf="images && thumbnailDisplay === 'grid'" class="{{ additionalClasses }}">
    <ion-row>
        <ng-container *ngFor="let img of images">
            <ion-col [size]="gridColumnWidth">
                <ng-content *ngTemplateOutlet="image; context: { img: img }"></ng-content>
            </ion-col>
        </ng-container>

        <ng-container *ngFor="let img of imagesAsString">
            <ion-col [size]="gridColumnWidth">
                <ng-content *ngTemplateOutlet="image; context: { img: img }"></ng-content>
            </ion-col>
        </ng-container>
    </ion-row>
</ion-grid>

<div *ngIf="images && thumbnailDisplay === 'slider'">
    <swiper-container
        class="{{ additionalClasses }}"
        [slidesPerView]="slidesPerView"
        [spaceBetween]="slideSpaceBetween"
        [pagination]="slidePagination">
        <ng-container>
            <swiper-slide *ngFor="let img of images">
                <ng-content *ngTemplateOutlet="image; context: { img: img }"></ng-content>
            </swiper-slide>

            <swiper-slide *ngFor="let img of imagesAsString">
                <ng-content *ngTemplateOutlet="image; context: { img: img }"></ng-content>
            </swiper-slide>
        </ng-container>
    </swiper-container>
</div>

<ng-template #image let-img="img">
    <ion-button class="gallery-lightbox--thumbnail-button" fill="clear" (click)="displayLightbox(img)">
        <img [src]="img.image_url || img" class="gallery-lightbox--thumbnail-image" />
    </ion-button>
</ng-template>
